import { clearAuth } from '@mms/composables/useUserStore';

export const guestRoutes = ['login', 'reset-password', 'otpVerification', 'forget-password'];

export const authGuard = (to, from, userStore) => {
  const { isAuthenticated } = userStore;

  const isRedirectedToLogin = to.name === 'login';

  const requiresAuth = !guestRoutes.includes(to.name) && !guestRoutes.includes(from.name);

  if (requiresAuth && !isAuthenticated.value && !isRedirectedToLogin) {
    clearAuth();
    return {
      name: 'login',
    };
  }
};
